import request from '@/common/request'

export default {
 
  // 可更换的锁列表
  getReplLocks: (param) => {
    return request({
      url: `/v1/lockManage/getReplLocks/${param}`,
      method: 'get',
    })
  },
  // 被更换锁具关联的任务列表
  getTaskList: (data) => {
    return request({
      url: `/v1/lockManage/getTaskList?lockId=${data.lockId}`,
      method: 'post',
    })
  },
  // 更换锁具
  replaceLock: (data) => {
    return request({
      url: "/v1/lockManage/replaceLock",
      method: 'post',
      data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/lockReplace.js